import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import './styles/Footer.css';
import './styles/Header.css';
import './styles/Buttons.css';
import './styles/Table.css';
import './styles/LandingPage.css';
import './styles/Modal.css';
import './styles/AttachmentPreview.css';
import './styles/Dashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import './styles/scss/style.scss';
import './styles/ConfirmDialog.css';
import 'react-notifications/lib/notifications.css';
import './styles/Notification.css';
import './styles/scss/app/Filter.scss';
import { Route, Switch } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Dashboard from './components/Dashboard/Dashboard';
import SecuredRoute from './securityUtils/secureRoute';
import Signet from './components/Containers/Signet';
import User from './components/Containers/User';
import RoleList from './components/Containers/RoleList';
import Decision from './components/Containers/Decision';
import DecisionTypeList from './components/Containers/DecisionTypeList';
import { isArray } from 'lodash';
import LoadingIndicator from './components/Reusable/LoadingIndicator';
import userActionsRoutes from './constants/user-actions-routes';
import RequestForSignetApproval from './components/Containers/RequestForSignetApproval';
import RequestForSignetApprovalProcessingView from './components/RequestForSignetApproval/ProcessingView.js/RequestForSignetApprovalProcessingView';
import SignetProcessingView from './components/Signet/ProcessingView/SignetProcessingView';
import Kjs from './components/Containers/Kjs';
import SignetExampleList from './components/Containers/SignetExampleList';
import Place from './components/Containers/Place';
import SigninRedirectPage from './components/SigninRedirectPage/SigninRedirectPage';
import { getLoggedInUser, getAllowedActions } from './actions/security';
import {
  locale,
  notificationTypeError,
  sessionStoragePRO,
} from './constants/globals';
import { NotificationContainer } from 'react-notifications';
import UnauthorizedAccess from './securityUtils/unauthorizedAccess';
import Instruction from './components/Instruction/Instruction';
import {
  tokenBeforeExpirationCheck,
  tokenExpirationCheck,
} from './securityUtils/tokenData';
import AuthenticationService from './securityUtils/AuthenticationService';
import { createNotification, fetchLocaleFromLocalStorage } from './utils';
import Municipality from './components/Containers/Municipality';
import withTranslations from './utils/HighOrderComponent';
import SigninPage from './components/SigninRedirectPage/SigninPage';

const token = sessionStorage[sessionStoragePRO];
require('dotenv').config();

!fetchLocaleFromLocalStorage() &&
  localStorage.setItem('locale', locale.default);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syncSignal: false,
      shouldCheckForTokenExpiration: true,
    };
  }

  componentDidMount() {
    if (token) {
      this.props.getLoggedInUser();
      this.props.getAllowedActions();
    }
  }

  componentDidUpdate(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      !this.state.shouldCheckForTokenExpiration &&
        tokenBeforeExpirationCheck() &&
        this.setState({ shouldCheckForTokenExpiration: true });
    }
  }

  syncLoadingStop = () => {
    this.setState({ syncSignal: false });
  };

  syncLoadingStart = () => {
    this.setState({ syncSignal: true });
  };

  checkRoute = (component, route, allowedActions) => {
    const action = userActionsRoutes[route];
    if (action && isArray(action)) {
      action.forEach((element) => {
        if (allowedActions?.includes(element)) {
          return;
        }
      });
      return component;
    } else if (action && allowedActions?.includes(action)) {
      return component;
    }

    return Dashboard;
  };

  tokenRenewalHandler = () => {
    if (
      this.state.shouldCheckForTokenExpiration &&
      tokenBeforeExpirationCheck()
    ) {
      AuthenticationService.renewToken();
      this.setState({
        shouldCheckForTokenExpiration: false,
      });
    }
  };

  tokenExpirationHandler = () => {
    if (tokenExpirationCheck()) {
      const { NotificationMessages } = this.props?.gt || {},
        { errorTitle, errorMessage } = NotificationMessages || {};
      createNotification(notificationTypeError, errorTitle, errorMessage);
      setTimeout(() => {
        AuthenticationService.login();
      }, 3050);
    }
  };

  render() {
    const { allowedActions, validToken } = this.props.loggedUser || {};
    const { loading, items } = allowedActions || {};

    if (this.state.syncSignal || loading) {
      return <LoadingIndicator syncSignal={this.state.syncSignal} />;
    }

    this.tokenRenewalHandler();
    this.tokenExpirationHandler();

    return (
      <div className="App">
        <Route exact path="/signin-oidc" component={SigninRedirectPage} />
        <Header userAllowedActions={items} />
        <Route
          exact
          path="/unauthorizedAccess"
          component={UnauthorizedAccess}
        />
        <Switch>
          <Route exact path="/signout-callback-oidc" component={Dashboard} />
          <Route exact path="/signin" component={SigninPage} />
          <Route
            exact
            path="/"
            component={Dashboard}
            token={token}
            validToken={validToken}
          />
          <SecuredRoute
            exact
            path="/users"
            component={this.checkRoute(User, '/users', items)}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/roleList"
            component={this.checkRoute(RoleList, '/roleList', items)}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/usersOfPublicFunds"
            component={this.checkRoute(Kjs, '/usersOfPublicFunds', items)}
            token={token}
            validToken={validToken}
            syncLoadingStop={this.syncLoadingStop}
            syncLoadingStart={this.syncLoadingStart}
          />

          <SecuredRoute
            exact
            path="/place"
            component={this.checkRoute(Place, '/place', items)}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/municipality"
            component={this.checkRoute(Municipality, '/municipality', items)}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/decision"
            component={this.checkRoute(Decision, '/decision', items)}
            token={token}
            validToken={validToken}
          />
          <SecuredRoute
            exact
            path="/signet"
            component={this.checkRoute(Signet, '/signet', items)}
            token={token}
            validToken={validToken}
          />
          <SecuredRoute
            exact
            path="/decisionTypeList"
            component={this.checkRoute(
              DecisionTypeList,
              '/decisionTypeList',
              items
            )}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/requestForSignetApproval"
            component={this.checkRoute(
              RequestForSignetApproval,
              '/requestForSignetApproval',
              items
            )}
            token={token}
            validToken={validToken}
          />
          <SecuredRoute
            exact
            path="/requestForSignetApprovalProcessingView/:id"
            component={this.checkRoute(
              RequestForSignetApprovalProcessingView,
              '/requestForSignetApprovalProcessingView',
              items
            )}
            token={token}
            validToken={validToken}
          />

          <SecuredRoute
            exact
            path="/signetProcessingView/:id"
            component={this.checkRoute(
              SignetProcessingView,
              '/signetProcessingView',
              items
            )}
            token={token}
            validToken={validToken}
          />
          <SecuredRoute
            exact
            path="/signetExampleList"
            component={this.checkRoute(
              SignetExampleList,
              '/signetExampleList',
              items
            )}
            token={token}
            validToken={validToken}
          />

          <Route exact path="/instruction" component={Instruction} />
        </Switch>

        <NotificationContainer />
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedUser: state.loggedUser,
    kjs: state.kjs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllowedActions: () => dispatch(getAllowedActions()),
    getLoggedInUser: () => dispatch(getLoggedInUser()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(App));
